
import React from 'react';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const Logo = ({ width = 50, height = 50, className = "" }: LogoProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4338ca" />
          <stop offset="50%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
        <linearGradient id="innerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#ec4899" />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
        <radialGradient id="highlight" cx="30%" cy="30%" r="70%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.4)" />
          <stop offset="100%" stopColor="transparent" />
        </radialGradient>
      </defs>
      
      {/* Outer glow ring */}
      <circle 
        cx="25" 
        cy="25" 
        r="23" 
        fill="none" 
        stroke="url(#logoGradient)" 
        strokeWidth="2"
        opacity="0.6"
        filter="url(#glow)"
      />
      
      {/* Main circle with gradient */}
      <circle 
        cx="25" 
        cy="25" 
        r="20" 
        fill="url(#logoGradient)" 
        className="drop-shadow-lg"
      />
      
      {/* Inner design - stylized "D" with modern twist */}
      <g transform="translate(25, 25)">
        {/* Background circle for the letter */}
        <circle 
          cx="0" 
          cy="0" 
          r="14" 
          fill="url(#innerGradient)" 
          opacity="0.9"
        />
        
        {/* Stylized "D" shape */}
        <path 
          d="M-6,-8 L-6,8 L2,8 C6,8 8,4 8,0 C8,-4 6,-8 2,-8 Z M-2,-4 L2,-4 C4,-4 4,-2 4,0 C4,2 4,4 2,4 L-2,4 Z"
          fill="white"
          opacity="0.95"
        />
        
        {/* Modern accent lines */}
        <line x1="10" y1="-6" x2="14" y2="-10" stroke="white" strokeWidth="2" opacity="0.7" strokeLinecap="round"/>
        <line x1="10" y1="6" x2="14" y2="10" stroke="white" strokeWidth="2" opacity="0.7" strokeLinecap="round"/>
        <circle cx="12" cy="0" r="1.5" fill="white" opacity="0.8"/>
      </g>
      
      {/* Highlight overlay */}
      <circle 
        cx="25" 
        cy="25" 
        r="20" 
        fill="url(#highlight)" 
      />
    </svg>
  );
};

export default Logo;
